module.exports = __webpack_public_path__ + "img/bsn_3.6c49006f.png";